import React from "react";

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div id="footer-div mt-4" className="text-center text-muted py-3">
      Copyright © {currentYear}{" "}
      <a href="https://bettertrucks.com/">Better Trucks Address Analytics Portal</a>.
      All rights reserved.
    </div>
  );
};

export default Footer;
